import { renderRoutes } from "react-router-config";

import { Registration } from "../containers/registration";
import { Login } from "../containers/login";
import { ResetPassword } from "../containers/resetPassword";
import { SetNewPassword } from "../containers/setNewPassword";
import { Profile } from "../containers/userProfile";
import { Events } from "../containers/eventsList";
import { Teams } from "../containers/teamsList";
import { CreateTeam } from "../containers/createTeam";
import { TeamProfile } from "../containers/teamProfile";
import { EventProfile } from "../containers/eventProfile";
import { withRedirectToAuth, withRedirectToHome } from "../containers/withAuth";
import Sponsors from "../containers/sponsors";

const _routes = [
  {
    path: "/",
    exact: true,
    component: withRedirectToHome(Login),
  },
  {
    path: "/registration",
    exact: true,
    component: withRedirectToHome(Registration),
  },
  {
    path: "/login",
    exact: true,
    component: withRedirectToHome(Login),
  },
  {
    path: "/forgot_password",
    exact: true,
    component: withRedirectToHome(ResetPassword),
  },
  {
    path: "/reset_password",
    exact: true,
    component: withRedirectToHome(SetNewPassword),
  },
  {
    path: "/profile",
    exact: true,
    component: withRedirectToAuth(Profile),
  },
  {
    path: "/events",
    exact: true,
    component: withRedirectToAuth(Events),
  },
  {
    path: "/teams",
    exact: true,
    component: withRedirectToAuth(Teams),
  },
  {
    path: "/teams/create",
    exact: true,
    component: withRedirectToAuth(CreateTeam),
  },
  {
    path: `/teams/:id`,
    exact: true,
    component:  withRedirectToAuth(TeamProfile),
  },
  {
    path: `/events/:id`,
    exact: true,
    component: EventProfile,
  },
  {
    path: `/sponsors`,
    exact: true,
    component: Sponsors,
  },
];
export const routes = renderRoutes(_routes);
